export const getScrollPosition = () => {
  return window.scrollY;
};

export const getCurrentPathName = (): string => {
  return document.location.pathname;
};
